import { Injectable } from '@angular/core';
import { LoyaltySsoService } from './loyalty-sso.service';
import { IMenuClickHandler } from '../tokens/menu-click-handler.token';

@Injectable({
  providedIn: 'root'
})
export class LoyaltyMenuClickHandlerService implements IMenuClickHandler {
  private readonly codes: string[];

  constructor(private ssoService: LoyaltySsoService) {
    this.codes = ssoService.getAllCodes();
  }

  getCodes() {
    return this.codes;
  }

  // @loyaltyDocs: menu item will use this method as click handler
  // if it finds it's code in the list from getCodes()
  execute(code: string, $event: MouseEvent) {
    $event.preventDefault();
    $event.stopPropagation();
    this.ssoService.openLink(code);
  }
}
